/**
 * @file 注销冷静期全局拦截
 * @desc 律师在注销冷静期内（deregister status=1），账号能力冻结，
 *       仅允许访问 /material（冷静期页/撤回入口），访问其它页面强制跳转到 /material。
 */
import {getDeregisterStatus} from '@/request/deregister';

// 冷静期内允许访问的路径：冷静期页/撤回入口所在页(/material)，以及登录页(避免无法登出)
const COOLDOWN_ALLOW_PATHS = ['/material', '/login'];

// 冷静期状态缓存，避免每次路由跳转都请求接口
let statusLoaded = false;
let inCooldown = false;

/**
 * 刷新冷静期状态。
 * 登录后首次进入由路由守卫自动拉取；提交注销申请 / 撤回申请后需主动调用以同步锁定状态。
 */
export const refreshDeregisterCooldown = async () => {
    try {
        const res = await getDeregisterStatus();
        inCooldown = +res.code === 0 && res.data && +res.data.status === 1;
    }
    catch (e) {
        // 接口异常时不锁定，避免误拦截把律师挡在外面
        inCooldown = false;
    }
    statusLoaded = true;
    return inCooldown;
};

/**
 * 路由守卫拦截。
 * @returns {Promise<boolean>} true 表示本拦截已处理（已调用 next），false 表示未拦截，交给后续逻辑
 */
export const deregisterCooldownIntercept = async (to, from, next) => {
    if (!statusLoaded) {
        await refreshDeregisterCooldown();
    }
    if (!inCooldown) {
        return false;
    }
    if (COOLDOWN_ALLOW_PATHS.includes(to.path)) {
        next();
    }
    else {
        next('/material');
    }
    return true;
};
